export const XVVS_LAUNCH_DATE = 1648080000000
